import { CustomFieldDefinition } from '@alucio/aws-beacon-amplify/src/models';

export const parseDependentFieldId = (dependentFieldId: string): {
  parentFieldId: string;
  subkey?: string;
} => {
  const parts = dependentFieldId.split('.');

  if (parts.length >= 2) {
    return {
      parentFieldId: parts[0],
      subkey: parts.slice(1).join('.'),
    };
  }

  return { parentFieldId: dependentFieldId };
};

export const isCRMAccountSearcherDependentField = (
  field: CustomFieldDefinition,
  parentField?: CustomFieldDefinition,
): boolean => {
  if (!field.dependentFieldId || !parentField) return false;

  const { parentFieldId } = parseDependentFieldId(field.dependentFieldId);
  if (parentFieldId !== parentField.id) return false;

  return parentField.controlType === 'CRMACCOUNTSEARCHER';
};
